// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1d3ek","error":"Textarea_error__3Ie-P","readonly":"Textarea_readonly__3rhtL","disabled":"Textarea_disabled__33iZh"};